import { useState, useEffect } from 'react';

const QUIZ_NOTIFICATION_KEY = 'quiz-notification-hidden';

export const useQuizNotification = () => {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const isHidden = localStorage.getItem(QUIZ_NOTIFICATION_KEY) === 'true';
    setShowNotification(!isHidden);
  }, []);

  const hideNotification = (dontShowAgain: boolean) => {
    if (dontShowAgain) {
      localStorage.setItem(QUIZ_NOTIFICATION_KEY, 'true');
    }
    setShowNotification(false);
  };

  const resetNotification = () => {
    localStorage.removeItem(QUIZ_NOTIFICATION_KEY);
    setShowNotification(true);
  };

  return {
    showNotification,
    hideNotification,
    resetNotification,
  };
}; 